<bp-hl-area-container name="Aufnahme">
	<div class="touch-form">
		<div class="form-row">
			<div class="form-label-cell">Punktart</div>
			<div class="form-input-cell">
				<bp-punktart-picker *ngIf="!commenting" [type]="data.type" (typeChange)="onPunktartPicked($event)"></bp-punktart-picker>
				<wd-typeahead *ngIf="commenting" [(model)]="punktartModel" name="PunktartMitProtokoll"></wd-typeahead>
			</div>
			<div class="form-label-cell">Nummer <wd-help name="Nummer"></wd-help></div>
			<div class="form-input-cell multi">
				<wd-text-input name="Nummer" [(model)]="data.header.nummer" nonEmpty (modified)="onNummerChanged($event)"></wd-text-input>
				<button *ngIf="canGenerateNummer()" type="button" class="btn btn-info btn-sm" (click)="generateNummer()" title="Punktnummer aus FA-Revier-Nr-Jahr generieren"><i class="bi bi-hash"></i></button>
				<!-- Gedaechtnisstuetze: meine zuletzt vergebenen Nummern im aktiven Projekt.
				     Nur fuer Angemeldete mit Personendaten-Recht - die Liste ist die eigene
				     Nummernvergabe samt Aufnahmedatum; ohne eigene Punkte sagt sie das. -->
				<button *ngIf="canSeePersonalData()" type="button" class="btn btn-outline-secondary btn-sm"
					[ngbPopover]="nummernPopover" [popoverTitle]="nummernPopoverTitle"
					popoverClass="nummern-popover" placement="bottom" container="body"
					title="Meine zuletzt vergebenen Nummern in diesem Projekt">
					<i class="bi bi-list-ul"></i>
				</button>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Datum</div>
			<div class="form-input-cell">
				<wd-date-input *ngIf="canSeePersonalData()" name="Aufnahmedatum" [(model)]="data.header.aufnahme.datum" nonEmpty></wd-date-input>
				<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
			</div>
			<div class="form-label-cell">Kartierer</div>
			<div class="form-input-cell">
				<!-- Owner/Entwickler: Nutzer-Auswahl; setzt Name + Eigentum (createdBy) gekoppelt. -->
				<wd-list-input *ngIf="canChangeKartierer()" name="KartiererAuswahl"
					[model]="data.header.aufnahme.kartierer" (modelChange)="onKartiererSelected($event)"
					[options]="kartiererOptions" [acceptOtherValues]="true"></wd-list-input>
				<!-- Alle anderen: nur lesend (maskiert für Nutzer ohne Personendaten-Recht). -->
				<span *ngIf="!canChangeKartierer() && canSeePersonalData()" class="readonly-value">{{ data.header.aufnahme.kartierer || '–' }}</span>
				<span *ngIf="!canChangeKartierer() && !canSeePersonalData()" class="masked-value">–</span>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Labornummer</div>
			<div class="form-input-cell">
				<wd-text-input name="Labornummer" [(model)]="data.header.labornummer"></wd-text-input>
			</div>
			<div class="form-label-cell">Laborstatus</div>
			<div class="form-input-cell">
				<wd-list-input name="Status Laboranalyse" [(model)]="data.header.statusLaboranalyse" options="|noch nicht ausgewertet|Ergebnis liegt vor"></wd-list-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Projekt</div>
			<div class="form-input-cell">
				<span class="readonly-value">{{ projekteString() }}</span>
			</div>
		</div>
	</div>

	<ng-template #nummernPopover>
		<div class="nummern-liste">
			<div *ngIf="letzteNummern.length === 0" class="nummern-leer">Noch keine eigenen Punkte mit Nummer in diesem Projekt.</div>
			<div *ngFor="let e of letzteNummern" class="nummer-eintrag">
				<span>{{ e.nummer }}</span>
				<span *ngIf="e.datum" class="nummer-datum">{{ e.datum | date:'dd.MM.yyyy' }}</span>
			</div>
		</div>
	</ng-template>
</bp-hl-area-container>
